import React, { useState, useEffect} from "react";
import { withRouter, Link } from "react-router-dom";
import Hamburger from "./Hamburger";
import { ThemeContext, themes } from '../ThemeProvider/themeContext';


// Import Assets
import Logo from '../assets/images/logo.svg';


const Header = ({ history }) => {
  const [darkMode, setDarkMode] = React.useState(true);
  const [disabled, setDisabled] = useState(false);
  const [scroll, setScroll] = useState(false);
  // const locationOuter = useHistory() 

  
  // State of our Menu
  const [state, setState] = useState({
    initial: false,
    clicked: null,
    menuName: "Menu"
  });

  // Listen to the page change
  useEffect(() => {
    history.listen((location) => {
      setState({ clicked: false, menuName: "Menu" });      
      // Add custom dynamic class
      if (location.pathname.replace('/', '') === 'our-work' 
        || location.pathname.replace('/', '') === 'about-us' 
        || location.pathname.replace('/', '') === 'contact-us' 
        || location.pathname.replace('/', '') === 'services' 
        || location.pathname.replace('/', '') === 'privacy-policy' 
        || location.pathname.replace('/', '') === 'terms-and-conditions' 
        || location.pathname.replace('/', '') === 'pfizer-keep-it-real' 
        || location.pathname.replace('/', '') === 'spectra-draw-the-line' 
        || location.pathname.replace('/', '') === 'godaddy-india' 
        || location.pathname.replace('/', '') === 'upes-shakti' 
        || location.pathname.replace('/', '') === 'my-cams-app' 
        || location.pathname.replace('/', '') === 'our-culture'){
        document.body.classList.add("custom-class");
        document.body.classList.remove("home-class");
      }
    });
  }, [history]);

  // Toggle menu
  const handleMenu = () => {
    disableMenu();
    if (state.initial === false) {
      document.body.classList.add("menu-opened");
      setState({
        initial: null,
        clicked: true,
        menuName: "Close"
      });
      
    } else if (state.clicked === true) {
      setState({
        clicked: !state.clicked,
        menuName: "Menu"
      });
      document.body.classList.add("menu-closed");
      document.body.classList.remove("menu-opened");
    } else if (state.clicked === false) {
      setState({
        clicked: !state.clicked,
        menuName: "Close"
      });
      document.body.classList.remove("menu-closed");
      document.body.classList.add("menu-opened");
    }
  };

  //Determine if out menu button should be disabled
  const disableMenu = () => {
    setDisabled(!disabled);
    setTimeout(() => {
      setDisabled(false);
    }, 1200);
  };

  // Header Sticky
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 80);
    });
   }, []);

  return (
    <header className={`${scroll ? "header-scrolled" : "header-normal"}`}>
      <div className="container">
        <div className="max-w-default w-default lg:px-12 md:px-6 sm:px-[15px] xs:px-[15px] header-wrapper">
          <div className="inner-header">
            <div className="logo">
              <Link to="/">
                <img src={Logo} alt="Logo"/>
              </Link>
            </div>
            <div className="theme-toggle">
            <ThemeContext.Consumer>
              {({ changeTheme }) => (
                <button
                  onClick={() => {
                    setDarkMode(!darkMode);
                    changeTheme(darkMode ? themes.dark : themes.light);
                  }}>
                  <i className={darkMode ? 'fas fa-sun' : 'fas fa-moon'}></i>
                  {/* <span className="d-lg-none d-md-block">{darkMode ? themes.light : themes.dark}</span> */}
                </button>
              )}
            </ThemeContext.Consumer>
          </div>
            <div className="menu">
              <button disabled={disabled} onClick={handleMenu}>
                {state.menuName} 
              </button>
              <span disabled={disabled} onClick={handleMenu}></span>
            </div>
          </div>
        </div>
      </div>
      <Hamburger state={state} />
    </header>
  );
};

export default withRouter(Header);
